module.exports = __webpack_public_path__ + "static/media/hardik_mutha.19fa7437.png";